import ReactOnRails from 'react-on-rails';
import NUps from '../customer_pages/_shelf-category/n-ups';

// This is how react_on_rails can see the Nups in the browser.

ReactOnRails.register({
  NUps
});
